var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.029,
    height: 82.899,
    viewBox: "0 0 58.029 82.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_816",
    "data-name": "Grupo 816",
    transform: "translate(-1333 -701.102)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_89",
    "data-name": "Elipse 89",
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    transform: "translate(1337 706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_person_pin_circle_24px",
    d: "M34.015,2A29.047,29.047,0,0,0,5,31.015C5,52.776,34.015,84.9,34.015,84.9s2.843-3.147,6.983-8.44C49.335,65.8,63.029,45.964,63.029,31.015A29.047,29.047,0,0,0,34.015,2Zm0,8.29a8.29,8.29,0,1,1-8.29,8.29A8.314,8.314,0,0,1,34.015,10.29Zm0,41.45a19.824,19.824,0,0,1-16.58-8.912c.083-5.471,11.067-8.5,16.58-8.5s16.5,3.026,16.58,8.5A19.824,19.824,0,0,1,34.015,51.739Z",
    transform: "translate(1328 699.102)",
    fill: "#0077da"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.f2d54a24.svg";
export { ForwardRef as ReactComponent };